export const translations = {
  fr: {
    nav: { home: "Accueil", jobs: "Offres d'emploi", login: "Connexion", register: "S'inscrire", logout: "Déconnexion", dashboard: "Tableau de bord" },
    lang: { choose: "Langue", fr: "Français", en: "English", es: "Español" },
    landing: {
      badge: "Plateforme de recrutement multilingue",
      heroTitle: "Trouvez les meilleurs talents. Décrochez le job idéal.",
      heroSubtitle: "Global Line Services connecte les entreprises qui recrutent avec les candidats qui veulent évoluer. Publiez vos offres, postulez en ligne, suivez vos candidatures — en français, anglais ou espagnol.",
      ctaCandidate: "Je cherche un emploi",
      ctaCompany: "Je recrute",
      browseJobs: "Voir les offres",
      jobsAvailable: "offres disponibles",
      statsJobs: "Offres actives",
      statsCompanies: "Entreprises",
      statsCandidates: "Candidats",
      featuresTitle: "Une plateforme, deux expériences",
      featuresSubtitle: "Des outils pensés pour les recruteurs comme pour les candidats.",
      forCompanies: "Pour les entreprises",
      f1: "Publiez et gérez vos offres en quelques clics",
      f2: "Recevez et filtrez les candidatures en temps réel",
      f3: "Consultez les profils et CV des candidats",
      f4: "Suivez chaque candidature avec des statuts clairs",
      forCandidates: "Pour les candidats",
      c1: "Créez votre profil et importez votre CV",
      c2: "Recherchez et filtrez les offres par métier, lieu, type",
      c3: "Postulez en ligne en une minute",
      c4: "Suivez l'état de vos candidatures en direct",
      howTitle: "Comment ça marche ?",
      step1t: "Créez votre compte",
      step1d: "Inscrivez-vous comme entreprise ou candidat, par email ou avec Google.",
      step2t: "Complétez votre profil",
      step2d: "Entreprises : présentez votre activité. Candidats : importez votre CV.",
      step3t: "Recrutez ou postulez",
      step3d: "Publiez vos offres ou candidatez en ligne, puis suivez tout depuis votre espace.",
      ctaTitle: "Prêt à commencer ?",
      ctaSubtitle: "Rejoignez Global Line Services dès aujourd'hui.",
      footer: "© 2026 Global Line Services. Tous droits réservés.",
    },
    auth: {
      loginTitle: "Bon retour",
      loginSubtitle: "Connectez-vous à votre espace",
      registerTitle: "Créer un compte",
      registerSubtitle: "Rejoignez la plateforme en quelques secondes",
      email: "Adresse email",
      password: "Mot de passe",
      name: "Nom complet",
      loginBtn: "Se connecter",
      registerBtn: "Créer mon compte",
      orContinueWith: "ou continuer avec",
      google: "Continuer avec Google",
      noAccount: "Pas encore de compte ?",
      hasAccount: "Déjà un compte ?",
      iAm: "Je suis",
      aCandidate: "Un candidat",
      aCompany: "Une entreprise",
      candidateDesc: "Je recherche un emploi",
      companyDesc: "Je publie des offres",
      chooseRoleTitle: "Bienvenue ! Une dernière étape",
      chooseRoleSubtitle: "Dites-nous qui vous êtes pour personnaliser votre expérience",
      continue: "Continuer",
      loginError: "Email ou mot de passe incorrect",
      registerError: "Impossible de créer le compte",
      accountBlocked: "Votre compte a été bloqué. Contactez l'administrateur.",
      forgotLink: "Mot de passe oublié ?",
      forgotTitle: "Mot de passe oublié",
      forgotSubtitle: "Entrez votre email pour recevoir un lien de réinitialisation.",
      sendResetLink: "Envoyer le lien",
      resetEmailSent: "Si un compte existe pour cet email, un lien de réinitialisation vient d'être envoyé.",
      backToLogin: "Retour à la connexion",
      resetTitle: "Nouveau mot de passe",
      resetSubtitle: "Choisissez votre nouveau mot de passe",
      newPassword: "Nouveau mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      passwordsMismatch: "Les mots de passe ne correspondent pas",
      resetBtn: "Réinitialiser",
      resetSuccess: "Mot de passe modifié avec succès ! Vous pouvez vous connecter.",
      resetInvalid: "Ce lien est invalide ou a expiré. Faites une nouvelle demande.",
    },
    jobs: {
      title: "Offres d'emploi",
      subtitle: "Trouvez l'opportunité qui vous correspond",
      searchPlaceholder: "Poste, mot-clé, entreprise...",
      locationPlaceholder: "Ville, région...",
      search: "Rechercher",
      filters: "Filtres",
      jobType: "Type de contrat",
      category: "Catégorie",
      all: "Toutes",
      reset: "Réinitialiser",
      results: "offre(s) trouvée(s)",
      noResults: "Aucune offre ne correspond à votre recherche.",
      postedOn: "Publié le",
      apply: "Postuler",
      applied: "Candidature envoyée",
      viewJob: "Voir l'offre",
      aboutJob: "Description du poste",
      aboutCompany: "À propos de l'entreprise",
      applyTitle: "Postuler à cette offre",
      applyMessage: "Message de motivation (optionnel)",
      applyMessagePlaceholder: "Présentez-vous en quelques lignes...",
      submitApplication: "Envoyer ma candidature",
      loginToApply: "Connectez-vous pour postuler",
      applicationSent: "Candidature envoyée avec succès !",
      alreadyApplied: "Vous avez déjà postulé à cette offre",
      salary: "Salaire",
      inactive: "Cette offre n'est plus disponible",
      requirementsLabel: "Qualifications requises",
      minExpLabel: "Expérience requise",
      yourExperience: "Vos années d'expérience",
      selectExperience: "Sélectionnez...",
      recruiterQuestions: "Questions du recruteur",
      answerPlaceholder: "Votre réponse...",
      cvFromProfile: "Votre CV de profil sera joint à votre candidature",
      noCvWarning: "Astuce : ajoutez votre CV dans votre profil pour renforcer votre candidature.",
      firstName: "Prénom",
      lastName: "Nom",
      birthdate: "Date de naissance",
      proExperience: "Expérience professionnelle",
      proExperiencePlaceholder: "Décrivez vos expériences (postes, entreprises, durées)...",
      qualificationsLabel: "Vos qualifications",
      qualificationsPlaceholder: "Diplômes, certifications, compétences clés...",
    },
    jobTypes: { full_time: "CDI / Temps plein", part_time: "Temps partiel", contract: "CDD / Contrat", internship: "Stage", freelance: "Freelance", remote: "Télétravail" },
    experience: { "lt1": "Moins d'1 an", "1-3": "1 à 3 ans", "3-5": "3 à 5 ans", "5+": "Plus de 5 ans" },
    categories: { tech: "Tech / IT", marketing: "Marketing", sales: "Vente", design: "Design", finance: "Finance", hr: "RH", health: "Santé", education: "Éducation", other: "Autre" },
    status: { pending: "En attente", reviewed: "Examinée", interview: "Entretien", rejected: "Refusée", hired: "Embauché", active: "Active", inactive: "Désactivée" },
    company: {
      overview: "Aperçu",
      myJobs: "Mes offres",
      applications: "Candidatures",
      profile: "Profil entreprise",
      totalJobs: "Offres publiées",
      activeJobs: "Offres actives",
      totalApplications: "Candidatures reçues",
      pendingApplications: "En attente",
      newJob: "Publier une offre",
      editJob: "Modifier l'offre",
      jobTitle: "Titre du poste",
      jobTitlePlaceholder: "Ex : Développeur Full-Stack",
      description: "Description",
      descriptionPlaceholder: "Décrivez le poste, les missions, le profil recherché...",
      location: "Lieu",
      locationPlaceholder: "Ex : Paris, France",
      type: "Type",
      salaryPlaceholder: "Ex : 45-60k€",
      create: "Publier",
      save: "Enregistrer",
      cancel: "Annuler",
      actions: "Actions",
      applicants: "candidat(s)",
      deactivate: "Désactiver",
      activate: "Activer",
      delete: "Supprimer",
      edit: "Modifier",
      deleteConfirm: "Supprimer définitivement cette offre et ses candidatures ?",
      noJobs: "Vous n'avez pas encore publié d'offre.",
      noApplications: "Aucune candidature reçue pour le moment.",
      filterByJob: "Filtrer par offre",
      filterByStatus: "Filtrer par statut",
      allJobs: "Toutes les offres",
      allStatuses: "Tous les statuts",
      candidate: "Candidat",
      job: "Offre",
      date: "Date",
      changeStatus: "Changer le statut",
      viewProfile: "Voir le profil",
      candidateProfile: "Profil du candidat",
      downloadCv: "Télécharger le CV",
      downloadCoverLetter: "Lettre de motivation",
      noCv: "Aucun CV importé",
      message: "Message",
      companyName: "Nom de l'entreprise",
      companyDescLabel: "Description de l'entreprise",
      website: "Site web",
      profileSaved: "Profil enregistré",
      jobCreated: "Offre publiée avec succès",
      jobUpdated: "Offre mise à jour",
      jobDeleted: "Offre supprimée",
      statusUpdated: "Statut mis à jour",
      companyLocation: "Siège / localisation",
      requirements: "Qualifications requises",
      requirementsPlaceholder: "Ex : Bac+5 informatique, maîtrise de React, anglais courant...",
      minExperience: "Années d'expérience requises",
      noRequirement: "Non précisé",
      questions: "Questions pour les candidats",
      addQuestion: "+ Ajouter une question",
      questionPlaceholder: "Ex : Êtes-vous disponible immédiatement ?",
      answers: "Réponses du candidat",
      declaredExperience: "Expérience déclarée",
      questionType: "Type de réponse",
      typeText: "Texte libre",
      typeYesNo: "Oui / Non",
    },
    candidate: {
      profile: "Mon profil",
      myApplications: "Mes candidatures",
      applicationsSubtitle: "Suivez l'état de vos candidatures en temps réel",
      noApplications: "Vous n'avez pas encore postulé. Parcourez les offres !",
      browseJobs: "Parcourir les offres",
      jobTitleLabel: "Titre du poste",
      jobTitlePlaceholder: "Ex : Développeuse Full-Stack",
      skills: "Compétences",
      skillsPlaceholder: "Ex : React, Node.js, Gestion de projet...",
      experience: "Expérience",
      experiencePlaceholder: "Ex : 5 ans en développement web",
      phone: "Téléphone",
      bio: "Présentation",
      bioPlaceholder: "Quelques mots sur vous...",
      cv: "CV",
      coverLetter: "Lettre de motivation",
      uploadCv: "Importer mon CV",
      uploadCoverLetter: "Importer ma lettre",
      uploading: "Envoi en cours...",
      uploadSuccess: "Fichier importé avec succès",
      uploadError: "Échec de l'envoi (PDF/DOC/DOCX, 10 Mo max)",
      currentFile: "Fichier actuel",
      download: "Télécharger",
      profileSaved: "Profil enregistré",
      viewJob: "Voir l'offre",
      appliedOn: "Postulé le",
      cvExamples: "Exemples de CV",
      cvExamplesDesc: "Téléchargez des modèles de CV pour vous inspirer.",
      cvExamplesEmpty: "Aucun exemple disponible pour le moment.",
    },
    admin: {
      dashboard: "Administration", jobsTab: "Toutes les offres", examplesTab: "Exemples de CV",
      company: "Entreprise", hide: "Masquer", show: "Afficher", hiddenJobs: "Offres masquées",
      addExample: "Ajouter un exemple de CV", exampleTitle: "Titre de l'exemple",
      exampleTitlePlaceholder: "Ex : CV Développeur Full-Stack", upload: "Ajouter", file: "Fichier",
      noExamples: "Aucun exemple de CV pour le moment.", exampleAdded: "Exemple de CV ajouté",
      exampleDeleted: "Exemple supprimé", deleteExampleConfirm: "Supprimer cet exemple de CV ?",
      usersTab: "Utilisateurs", user: "Utilisateur", role: "Rôle",
      block: "Bloquer", unblock: "Débloquer", blocked: "Bloqué", activeUser: "Actif",
      resetPassword: "Réinitialiser le mot de passe", newPassword: "Nouveau mot de passe",
      generate: "Générer", passwordReset: "Mot de passe réinitialisé",
      passwordResetHint: "Communiquez ce mot de passe à l'utilisateur concerné.",
      userBlocked: "Utilisateur bloqué", userUnblocked: "Utilisateur débloqué",
      noUsers: "Aucun utilisateur inscrit.",
    },
    common: { loading: "Chargement...", error: "Une erreur est survenue", back: "Retour", yes: "Oui", no: "Non", email: "Email", location: "Localisation" },
  },

  en: {
    nav: { home: "Home", jobs: "Jobs", login: "Log in", register: "Sign up", logout: "Log out", dashboard: "Dashboard" },
    lang: { choose: "Language", fr: "Français", en: "English", es: "Español" },
    landing: {
      badge: "Multilingual recruitment platform",
      heroTitle: "Find the best talent. Land the perfect job.",
      heroSubtitle: "Global Line Services connects hiring companies with candidates ready to grow. Post jobs, apply online, track applications — in French, English or Spanish.",
      ctaCandidate: "I'm looking for a job",
      ctaCompany: "I'm hiring",
      browseJobs: "Browse jobs",
      jobsAvailable: "jobs available",
      statsJobs: "Active jobs",
      statsCompanies: "Companies",
      statsCandidates: "Candidates",
      featuresTitle: "One platform, two experiences",
      featuresSubtitle: "Tools designed for recruiters and candidates alike.",
      forCompanies: "For companies",
      f1: "Post and manage your job offers in a few clicks",
      f2: "Receive and filter applications in real time",
      f3: "Browse candidate profiles and CVs",
      f4: "Track every application with clear statuses",
      forCandidates: "For candidates",
      c1: "Create your profile and upload your CV",
      c2: "Search and filter jobs by role, location, type",
      c3: "Apply online in one minute",
      c4: "Track your application status live",
      howTitle: "How it works",
      step1t: "Create your account",
      step1d: "Sign up as a company or candidate, by email or with Google.",
      step2t: "Complete your profile",
      step2d: "Companies: present your business. Candidates: upload your CV.",
      step3t: "Hire or apply",
      step3d: "Post your offers or apply online, then track everything from your space.",
      ctaTitle: "Ready to get started?",
      ctaSubtitle: "Join Global Line Services today.",
      footer: "© 2026 Global Line Services. All rights reserved.",
    },
    auth: {
      loginTitle: "Welcome back",
      loginSubtitle: "Log in to your account",
      registerTitle: "Create an account",
      registerSubtitle: "Join the platform in seconds",
      email: "Email address",
      password: "Password",
      name: "Full name",
      loginBtn: "Log in",
      registerBtn: "Create my account",
      orContinueWith: "or continue with",
      google: "Continue with Google",
      noAccount: "No account yet?",
      hasAccount: "Already have an account?",
      iAm: "I am",
      aCandidate: "A candidate",
      aCompany: "A company",
      candidateDesc: "I'm looking for a job",
      companyDesc: "I post job offers",
      chooseRoleTitle: "Welcome! One last step",
      chooseRoleSubtitle: "Tell us who you are to personalize your experience",
      continue: "Continue",
      loginError: "Incorrect email or password",
      registerError: "Could not create account",
      accountBlocked: "Your account has been blocked. Contact the administrator.",
      forgotLink: "Forgot password?",
      forgotTitle: "Forgot password",
      forgotSubtitle: "Enter your email to receive a reset link.",
      sendResetLink: "Send the link",
      resetEmailSent: "If an account exists for this email, a reset link has just been sent.",
      backToLogin: "Back to login",
      resetTitle: "New password",
      resetSubtitle: "Choose your new password",
      newPassword: "New password",
      confirmPassword: "Confirm password",
      passwordsMismatch: "Passwords do not match",
      resetBtn: "Reset",
      resetSuccess: "Password changed successfully! You can now log in.",
      resetInvalid: "This link is invalid or has expired. Please request a new one.",
    },
    jobs: {
      title: "Job offers",
      subtitle: "Find the opportunity that fits you",
      searchPlaceholder: "Role, keyword, company...",
      locationPlaceholder: "City, region...",
      search: "Search",
      filters: "Filters",
      jobType: "Contract type",
      category: "Category",
      all: "All",
      reset: "Reset",
      results: "job(s) found",
      noResults: "No jobs match your search.",
      postedOn: "Posted on",
      apply: "Apply",
      applied: "Application sent",
      viewJob: "View job",
      aboutJob: "Job description",
      aboutCompany: "About the company",
      applyTitle: "Apply for this job",
      applyMessage: "Cover message (optional)",
      applyMessagePlaceholder: "Introduce yourself in a few lines...",
      submitApplication: "Send my application",
      loginToApply: "Log in to apply",
      applicationSent: "Application sent successfully!",
      alreadyApplied: "You have already applied to this job",
      salary: "Salary",
      inactive: "This job is no longer available",
      requirementsLabel: "Required qualifications",
      minExpLabel: "Required experience",
      yourExperience: "Your years of experience",
      selectExperience: "Select...",
      recruiterQuestions: "Recruiter questions",
      answerPlaceholder: "Your answer...",
      cvFromProfile: "Your profile CV will be attached to your application",
      noCvWarning: "Tip: add your CV in your profile to strengthen your application.",
      firstName: "First name",
      lastName: "Last name",
      birthdate: "Date of birth",
      proExperience: "Professional experience",
      proExperiencePlaceholder: "Describe your experience (roles, companies, durations)...",
      qualificationsLabel: "Your qualifications",
      qualificationsPlaceholder: "Degrees, certifications, key skills...",
    },
    jobTypes: { full_time: "Full-time", part_time: "Part-time", contract: "Contract", internship: "Internship", freelance: "Freelance", remote: "Remote" },
    experience: { "lt1": "Less than 1 year", "1-3": "1 to 3 years", "3-5": "3 to 5 years", "5+": "More than 5 years" },
    categories: { tech: "Tech / IT", marketing: "Marketing", sales: "Sales", design: "Design", finance: "Finance", hr: "HR", health: "Healthcare", education: "Education", other: "Other" },
    status: { pending: "Pending", reviewed: "Reviewed", interview: "Interview", rejected: "Rejected", hired: "Hired", active: "Active", inactive: "Inactive" },
    company: {
      overview: "Overview",
      myJobs: "My jobs",
      applications: "Applications",
      profile: "Company profile",
      totalJobs: "Jobs posted",
      activeJobs: "Active jobs",
      totalApplications: "Applications received",
      pendingApplications: "Pending",
      newJob: "Post a job",
      editJob: "Edit job",
      jobTitle: "Job title",
      jobTitlePlaceholder: "E.g.: Full-Stack Developer",
      description: "Description",
      descriptionPlaceholder: "Describe the role, missions, ideal profile...",
      location: "Location",
      locationPlaceholder: "E.g.: Paris, France",
      type: "Type",
      salaryPlaceholder: "E.g.: $50-70k",
      create: "Publish",
      save: "Save",
      cancel: "Cancel",
      actions: "Actions",
      applicants: "applicant(s)",
      deactivate: "Deactivate",
      activate: "Activate",
      delete: "Delete",
      edit: "Edit",
      deleteConfirm: "Permanently delete this job and its applications?",
      noJobs: "You haven't posted any jobs yet.",
      noApplications: "No applications received yet.",
      filterByJob: "Filter by job",
      filterByStatus: "Filter by status",
      allJobs: "All jobs",
      allStatuses: "All statuses",
      candidate: "Candidate",
      job: "Job",
      date: "Date",
      changeStatus: "Change status",
      viewProfile: "View profile",
      candidateProfile: "Candidate profile",
      downloadCv: "Download CV",
      downloadCoverLetter: "Cover letter",
      noCv: "No CV uploaded",
      message: "Message",
      companyName: "Company name",
      companyDescLabel: "Company description",
      website: "Website",
      profileSaved: "Profile saved",
      jobCreated: "Job published successfully",
      jobUpdated: "Job updated",
      jobDeleted: "Job deleted",
      statusUpdated: "Status updated",
      companyLocation: "Headquarters / location",
      requirements: "Required qualifications",
      requirementsPlaceholder: "E.g.: Master's in CS, React expertise, fluent English...",
      minExperience: "Required years of experience",
      noRequirement: "Not specified",
      questions: "Questions for candidates",
      addQuestion: "+ Add a question",
      questionPlaceholder: "E.g.: Are you available immediately?",
      answers: "Candidate answers",
      declaredExperience: "Declared experience",
      questionType: "Answer type",
      typeText: "Free text",
      typeYesNo: "Yes / No",
    },
    candidate: {
      profile: "My profile",
      myApplications: "My applications",
      applicationsSubtitle: "Track the status of your applications in real time",
      noApplications: "You haven't applied yet. Browse the jobs!",
      browseJobs: "Browse jobs",
      jobTitleLabel: "Job title",
      jobTitlePlaceholder: "E.g.: Full-Stack Developer",
      skills: "Skills",
      skillsPlaceholder: "E.g.: React, Node.js, Project management...",
      experience: "Experience",
      experiencePlaceholder: "E.g.: 5 years in web development",
      phone: "Phone",
      bio: "About me",
      bioPlaceholder: "A few words about you...",
      cv: "CV",
      coverLetter: "Cover letter",
      uploadCv: "Upload my CV",
      uploadCoverLetter: "Upload my letter",
      uploading: "Uploading...",
      uploadSuccess: "File uploaded successfully",
      uploadError: "Upload failed (PDF/DOC/DOCX, 10MB max)",
      currentFile: "Current file",
      download: "Download",
      profileSaved: "Profile saved",
      viewJob: "View job",
      appliedOn: "Applied on",
      cvExamples: "CV examples",
      cvExamplesDesc: "Download CV templates for inspiration.",
      cvExamplesEmpty: "No examples available yet.",
    },
    admin: {
      dashboard: "Administration", jobsTab: "All jobs", examplesTab: "CV examples",
      company: "Company", hide: "Hide", show: "Show", hiddenJobs: "Hidden jobs",
      addExample: "Add a CV example", exampleTitle: "Example title",
      exampleTitlePlaceholder: "E.g.: Full-Stack Developer CV", upload: "Add", file: "File",
      noExamples: "No CV examples yet.", exampleAdded: "CV example added",
      exampleDeleted: "Example deleted", deleteExampleConfirm: "Delete this CV example?",
      usersTab: "Users", user: "User", role: "Role",
      block: "Block", unblock: "Unblock", blocked: "Blocked", activeUser: "Active",
      resetPassword: "Reset password", newPassword: "New password",
      generate: "Generate", passwordReset: "Password reset",
      passwordResetHint: "Share this password with the user.",
      userBlocked: "User blocked", userUnblocked: "User unblocked",
      noUsers: "No registered users.",
    },
    common: { loading: "Loading...", error: "Something went wrong", back: "Back", yes: "Yes", no: "No", email: "Email", location: "Location" },
  },

  es: {
    nav: { home: "Inicio", jobs: "Ofertas de empleo", login: "Iniciar sesión", register: "Registrarse", logout: "Cerrar sesión", dashboard: "Panel" },
    lang: { choose: "Idioma", fr: "Français", en: "English", es: "Español" },
    landing: {
      badge: "Plataforma de reclutamiento multilingüe",
      heroTitle: "Encuentra el mejor talento. Consigue el trabajo ideal.",
      heroSubtitle: "Global Line Services conecta empresas que contratan con candidatos que quieren crecer. Publica ofertas, postúlate en línea y sigue tus candidaturas — en francés, inglés o español.",
      ctaCandidate: "Busco empleo",
      ctaCompany: "Estoy contratando",
      browseJobs: "Ver ofertas",
      jobsAvailable: "ofertas disponibles",
      statsJobs: "Ofertas activas",
      statsCompanies: "Empresas",
      statsCandidates: "Candidatos",
      featuresTitle: "Una plataforma, dos experiencias",
      featuresSubtitle: "Herramientas pensadas tanto para reclutadores como para candidatos.",
      forCompanies: "Para empresas",
      f1: "Publica y gestiona tus ofertas en pocos clics",
      f2: "Recibe y filtra candidaturas en tiempo real",
      f3: "Consulta perfiles y CV de los candidatos",
      f4: "Sigue cada candidatura con estados claros",
      forCandidates: "Para candidatos",
      c1: "Crea tu perfil y sube tu CV",
      c2: "Busca y filtra ofertas por puesto, lugar y tipo",
      c3: "Postúlate en línea en un minuto",
      c4: "Sigue el estado de tus candidaturas en directo",
      howTitle: "¿Cómo funciona?",
      step1t: "Crea tu cuenta",
      step1d: "Regístrate como empresa o candidato, por email o con Google.",
      step2t: "Completa tu perfil",
      step2d: "Empresas: presenta tu actividad. Candidatos: sube tu CV.",
      step3t: "Contrata o postúlate",
      step3d: "Publica tus ofertas o postúlate en línea y sigue todo desde tu espacio.",
      ctaTitle: "¿Listo para empezar?",
      ctaSubtitle: "Únete a Global Line Services hoy mismo.",
      footer: "© 2026 Global Line Services. Todos los derechos reservados.",
    },
    auth: {
      loginTitle: "Bienvenido de nuevo",
      loginSubtitle: "Inicia sesión en tu cuenta",
      registerTitle: "Crear una cuenta",
      registerSubtitle: "Únete a la plataforma en segundos",
      email: "Correo electrónico",
      password: "Contraseña",
      name: "Nombre completo",
      loginBtn: "Iniciar sesión",
      registerBtn: "Crear mi cuenta",
      orContinueWith: "o continuar con",
      google: "Continuar con Google",
      noAccount: "¿Aún no tienes cuenta?",
      hasAccount: "¿Ya tienes cuenta?",
      iAm: "Soy",
      aCandidate: "Candidato",
      aCompany: "Empresa",
      candidateDesc: "Busco empleo",
      companyDesc: "Publico ofertas",
      chooseRoleTitle: "¡Bienvenido! Un último paso",
      chooseRoleSubtitle: "Dinos quién eres para personalizar tu experiencia",
      continue: "Continuar",
      loginError: "Correo o contraseña incorrectos",
      registerError: "No se pudo crear la cuenta",
      accountBlocked: "Tu cuenta ha sido bloqueada. Contacta al administrador.",
      forgotLink: "¿Olvidaste tu contraseña?",
      forgotTitle: "Contraseña olvidada",
      forgotSubtitle: "Introduce tu email para recibir un enlace de restablecimiento.",
      sendResetLink: "Enviar el enlace",
      resetEmailSent: "Si existe una cuenta con este email, se acaba de enviar un enlace de restablecimiento.",
      backToLogin: "Volver al inicio de sesión",
      resetTitle: "Nueva contraseña",
      resetSubtitle: "Elige tu nueva contraseña",
      newPassword: "Nueva contraseña",
      confirmPassword: "Confirmar contraseña",
      passwordsMismatch: "Las contraseñas no coinciden",
      resetBtn: "Restablecer",
      resetSuccess: "¡Contraseña cambiada con éxito! Ya puedes iniciar sesión.",
      resetInvalid: "Este enlace es inválido o ha expirado. Haz una nueva solicitud.",
    },
    jobs: {
      title: "Ofertas de empleo",
      subtitle: "Encuentra la oportunidad que encaja contigo",
      searchPlaceholder: "Puesto, palabra clave, empresa...",
      locationPlaceholder: "Ciudad, región...",
      search: "Buscar",
      filters: "Filtros",
      jobType: "Tipo de contrato",
      category: "Categoría",
      all: "Todas",
      reset: "Restablecer",
      results: "oferta(s) encontrada(s)",
      noResults: "Ninguna oferta coincide con tu búsqueda.",
      postedOn: "Publicado el",
      apply: "Postularse",
      applied: "Candidatura enviada",
      viewJob: "Ver oferta",
      aboutJob: "Descripción del puesto",
      aboutCompany: "Sobre la empresa",
      applyTitle: "Postularse a esta oferta",
      applyMessage: "Mensaje de motivación (opcional)",
      applyMessagePlaceholder: "Preséntate en pocas líneas...",
      submitApplication: "Enviar mi candidatura",
      loginToApply: "Inicia sesión para postularte",
      applicationSent: "¡Candidatura enviada con éxito!",
      alreadyApplied: "Ya te has postulado a esta oferta",
      salary: "Salario",
      inactive: "Esta oferta ya no está disponible",
      requirementsLabel: "Cualificaciones requeridas",
      minExpLabel: "Experiencia requerida",
      yourExperience: "Tus años de experiencia",
      selectExperience: "Selecciona...",
      recruiterQuestions: "Preguntas del reclutador",
      answerPlaceholder: "Tu respuesta...",
      cvFromProfile: "Tu CV de perfil se adjuntará a tu candidatura",
      noCvWarning: "Consejo: añade tu CV en tu perfil para reforzar tu candidatura.",
      firstName: "Nombre",
      lastName: "Apellidos",
      birthdate: "Fecha de nacimiento",
      proExperience: "Experiencia profesional",
      proExperiencePlaceholder: "Describe tu experiencia (puestos, empresas, duración)...",
      qualificationsLabel: "Tus cualificaciones",
      qualificationsPlaceholder: "Títulos, certificaciones, habilidades clave...",
    },
    jobTypes: { full_time: "Tiempo completo", part_time: "Tiempo parcial", contract: "Contrato", internship: "Prácticas", freelance: "Freelance", remote: "Remoto" },
    experience: { "lt1": "Menos de 1 año", "1-3": "1 a 3 años", "3-5": "3 a 5 años", "5+": "Más de 5 años" },
    categories: { tech: "Tech / IT", marketing: "Marketing", sales: "Ventas", design: "Diseño", finance: "Finanzas", hr: "RRHH", health: "Salud", education: "Educación", other: "Otro" },
    status: { pending: "Pendiente", reviewed: "Revisada", interview: "Entrevista", rejected: "Rechazada", hired: "Contratado", active: "Activa", inactive: "Desactivada" },
    company: {
      overview: "Resumen",
      myJobs: "Mis ofertas",
      applications: "Candidaturas",
      profile: "Perfil de empresa",
      totalJobs: "Ofertas publicadas",
      activeJobs: "Ofertas activas",
      totalApplications: "Candidaturas recibidas",
      pendingApplications: "Pendientes",
      newJob: "Publicar una oferta",
      editJob: "Editar oferta",
      jobTitle: "Título del puesto",
      jobTitlePlaceholder: "Ej.: Desarrollador Full-Stack",
      description: "Descripción",
      descriptionPlaceholder: "Describe el puesto, las misiones, el perfil buscado...",
      location: "Ubicación",
      locationPlaceholder: "Ej.: Madrid, España",
      type: "Tipo",
      salaryPlaceholder: "Ej.: 40-55k€",
      create: "Publicar",
      save: "Guardar",
      cancel: "Cancelar",
      actions: "Acciones",
      applicants: "candidato(s)",
      deactivate: "Desactivar",
      activate: "Activar",
      delete: "Eliminar",
      edit: "Editar",
      deleteConfirm: "¿Eliminar definitivamente esta oferta y sus candidaturas?",
      noJobs: "Aún no has publicado ninguna oferta.",
      noApplications: "Aún no has recibido candidaturas.",
      filterByJob: "Filtrar por oferta",
      filterByStatus: "Filtrar por estado",
      allJobs: "Todas las ofertas",
      allStatuses: "Todos los estados",
      candidate: "Candidato",
      job: "Oferta",
      date: "Fecha",
      changeStatus: "Cambiar estado",
      viewProfile: "Ver perfil",
      candidateProfile: "Perfil del candidato",
      downloadCv: "Descargar CV",
      downloadCoverLetter: "Carta de motivación",
      noCv: "Ningún CV subido",
      message: "Mensaje",
      companyName: "Nombre de la empresa",
      companyDescLabel: "Descripción de la empresa",
      website: "Sitio web",
      profileSaved: "Perfil guardado",
      jobCreated: "Oferta publicada con éxito",
      jobUpdated: "Oferta actualizada",
      jobDeleted: "Oferta eliminada",
      statusUpdated: "Estado actualizado",
      companyLocation: "Sede / ubicación",
      requirements: "Cualificaciones requeridas",
      requirementsPlaceholder: "Ej.: Grado en informática, dominio de React, inglés fluido...",
      minExperience: "Años de experiencia requeridos",
      noRequirement: "No especificado",
      questions: "Preguntas para los candidatos",
      addQuestion: "+ Añadir una pregunta",
      questionPlaceholder: "Ej.: ¿Estás disponible inmediatamente?",
      answers: "Respuestas del candidato",
      declaredExperience: "Experiencia declarada",
      questionType: "Tipo de respuesta",
      typeText: "Texto libre",
      typeYesNo: "Sí / No",
    },
    candidate: {
      profile: "Mi perfil",
      myApplications: "Mis candidaturas",
      applicationsSubtitle: "Sigue el estado de tus candidaturas en tiempo real",
      noApplications: "Aún no te has postulado. ¡Explora las ofertas!",
      browseJobs: "Explorar ofertas",
      jobTitleLabel: "Título del puesto",
      jobTitlePlaceholder: "Ej.: Desarrolladora Full-Stack",
      skills: "Habilidades",
      skillsPlaceholder: "Ej.: React, Node.js, Gestión de proyectos...",
      experience: "Experiencia",
      experiencePlaceholder: "Ej.: 5 años en desarrollo web",
      phone: "Teléfono",
      bio: "Presentación",
      bioPlaceholder: "Unas palabras sobre ti...",
      cv: "CV",
      coverLetter: "Carta de motivación",
      uploadCv: "Subir mi CV",
      uploadCoverLetter: "Subir mi carta",
      uploading: "Subiendo...",
      uploadSuccess: "Archivo subido con éxito",
      uploadError: "Error al subir (PDF/DOC/DOCX, 10 MB máx)",
      currentFile: "Archivo actual",
      download: "Descargar",
      profileSaved: "Perfil guardado",
      viewJob: "Ver oferta",
      appliedOn: "Postulado el",
      cvExamples: "Ejemplos de CV",
      cvExamplesDesc: "Descarga plantillas de CV para inspirarte.",
      cvExamplesEmpty: "Aún no hay ejemplos disponibles.",
    },
    admin: {
      dashboard: "Administración", jobsTab: "Todas las ofertas", examplesTab: "Ejemplos de CV",
      company: "Empresa", hide: "Ocultar", show: "Mostrar", hiddenJobs: "Ofertas ocultas",
      addExample: "Añadir un ejemplo de CV", exampleTitle: "Título del ejemplo",
      exampleTitlePlaceholder: "Ej.: CV Desarrollador Full-Stack", upload: "Añadir", file: "Archivo",
      noExamples: "Aún no hay ejemplos de CV.", exampleAdded: "Ejemplo de CV añadido",
      exampleDeleted: "Ejemplo eliminado", deleteExampleConfirm: "¿Eliminar este ejemplo de CV?",
      usersTab: "Usuarios", user: "Usuario", role: "Rol",
      block: "Bloquear", unblock: "Desbloquear", blocked: "Bloqueado", activeUser: "Activo",
      resetPassword: "Restablecer contraseña", newPassword: "Nueva contraseña",
      generate: "Generar", passwordReset: "Contraseña restablecida",
      passwordResetHint: "Comunica esta contraseña al usuario.",
      userBlocked: "Usuario bloqueado", userUnblocked: "Usuario desbloqueado",
      noUsers: "No hay usuarios registrados.",
    },
    common: { loading: "Cargando...", error: "Algo salió mal", back: "Volver", yes: "Sí", no: "No", email: "Email", location: "Ubicación" },
  },
};
